.module {
  display: grid;
  gap: 24px;
  padding-top: 25px;
  color: #172033;
  font-family: Inter, Arial, sans-serif;
  font-size: 16px;
}

.module button,
.module input,
.module select,
.module textarea {
  font: inherit;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 30px 32px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-left: 8px solid var(--asset-accent, #0891b2);
  border-radius: 18px;
  background:
    radial-gradient(
      circle at 92% 8%,
      rgb(var(--asset-shadow-rgb, 8 145 178) / 18%),
      transparent 34%
    ),
    linear-gradient(135deg, #fff, var(--asset-soft, #ecfeff));
  box-shadow: 0 14px 34px rgb(var(--asset-shadow-rgb, 8 145 178) / 11%);
}

.bannerContent {
  display: grid;
  gap: 7px;
}

.bannerContent p,
.sectionHeader p,
.registerHeader p,
.modalHeader p {
  margin: 0;
  color: var(--asset-accent, #0891b2);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.bannerContent h1 {
  margin: 0;
  color: var(--asset-deep, #164e63);
  font-size: clamp(28px, 3vw, 36px);
  line-height: 1.2;
}

.bannerContent > span {
  color: #526579;
  font-size: 15px;
  line-height: 1.6;
}

.bannerActions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.primary,
.secondary {
  display: inline-flex;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 12px 20px;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.primary {
  border: 1px solid var(--asset-accent, #0891b2);
  background: var(--asset-accent, #0891b2);
  color: #fff;
}

.primary > span {
  font-size: 23px;
  font-weight: 500;
  line-height: 1;
}

.primary:hover:not(:disabled) {
  border-color: var(--asset-dark, #0e7490);
  background: var(--asset-dark, #0e7490);
  box-shadow: 0 9px 20px rgb(var(--asset-shadow-rgb, 8 145 178) / 22%);
  transform: translateY(-1px);
}

.primary:disabled {
  opacity: 0.55;
}

.secondary {
  border: 1px solid var(--asset-border, #a5f3fc);
  background: #fff;
  color: var(--asset-dark, #0e7490);
}

.secondary:hover {
  border-color: var(--asset-accent, #0891b2);
  background: var(--asset-soft, #ecfeff);
}

.error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 21px;
  border: 1px solid #fecaca;
  border-radius: 14px;
  background: #fff1f2;
  color: #9f1239;
  font-size: 14px;
}

.error > div {
  display: grid;
  gap: 4px;
}

.error button {
  padding: 9px 14px;
  border: 1px solid #e994a4;
  border-radius: 9px;
  background: #fff;
  color: #9f1239;
  font-weight: 800;
}

.statistics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.statistics article {
  display: grid;
  min-height: 108px;
  align-content: center;
  gap: 8px;
  padding: 21px 23px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 15px;
  background: linear-gradient(145deg, #fff, var(--asset-soft, #ecfeff));
  box-shadow: 0 7px 18px rgb(var(--asset-shadow-rgb, 8 145 178) / 7%);
}

.statistics span {
  color: #526579;
  font-size: 13px;
  font-weight: 700;
}

.statistics strong {
  color: var(--asset-deep, #164e63);
  font-size: 32px;
  line-height: 1;
}

.clientSection,
.register {
  overflow: hidden;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 30px rgb(var(--asset-shadow-rgb, 8 145 178) / 9%);
}

.sectionHeader,
.registerHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 24px 26px 20px;
  border-bottom: 1px solid var(--asset-border, #a5f3fc);
  background: linear-gradient(135deg, var(--asset-soft, #ecfeff), #fff 72%);
}

.sectionHeader > div,
.registerHeader > div {
  display: grid;
  gap: 5px;
}

.sectionHeader h2,
.registerHeader h2 {
  margin: 0;
  color: var(--asset-deep, #164e63);
  font-size: 23px;
}

.sectionHeader div > span,
.registerHeader div > span {
  color: #64748b;
  font-size: 14px;
}

.sectionHeader > b {
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--asset-pale, #cffafe);
  color: var(--asset-dark, #0e7490);
  font-size: 12px;
}

.clientGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  padding: 24px;
}

.clientCard {
  position: relative;
  isolation: isolate;
  display: grid;
  min-height: 320px;
  overflow: hidden;
  align-content: space-between;
  gap: 18px;
  padding: 24px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 18px;
  background:
    linear-gradient(145deg, rgb(255 255 255 / 98%), var(--asset-soft, #ecfeff)),
    #fff;
  color: #172033;
  box-shadow: 0 8px 24px rgb(var(--asset-shadow-rgb, 8 145 178) / 8%);
  text-align: left;
  transition:
    border-color 0.2s ease,
    box-shadow 0.25s ease,
    transform 0.25s ease;
}

.clientCard:hover {
  border-color: var(--asset-accent, #0891b2);
  box-shadow: 0 18px 38px rgb(var(--asset-shadow-rgb, 8 145 178) / 18%);
  transform: translateY(-5px);
}

.clientCardGlow {
  position: absolute;
  z-index: -1;
  top: -100px;
  right: -80px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgb(var(--asset-shadow-rgb, 8 145 178) / 22%),
    transparent 68%
  );
  transition: transform 0.35s ease;
}

.clientCard:hover .clientCardGlow {
  transform: scale(1.18) translate(-8px, 8px);
}

.clientCard header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.clientIcon {
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 14px;
  background: #fff;
  color: var(--asset-accent, #0891b2);
  box-shadow: 0 7px 16px rgb(var(--asset-shadow-rgb, 8 145 178) / 12%);
  font-size: 22px;
}

.clientCode {
  padding: 7px 10px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 999px;
  background: rgb(255 255 255 / 78%);
  color: var(--asset-dark, #0e7490);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.clientIdentity p {
  margin: 0;
  color: var(--asset-accent, #0891b2);
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.12em;
}

.clientIdentity h2 {
  min-height: 52px;
  margin: 7px 0 3px;
  color: var(--asset-deep, #164e63);
  font-size: 21px;
  line-height: 1.25;
}

.clientIdentity > span {
  color: #64748b;
  font-size: 12px;
}

.readinessTrack {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #e5edf2;
}

.readinessTrack span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--asset-accent, #0891b2), #35c48d);
}

.clientMetrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}

.clientMetrics > span {
  display: grid;
  gap: 3px;
  padding: 9px 8px;
  border: 1px solid rgb(226 232 240 / 90%);
  border-radius: 10px;
  background: rgb(255 255 255 / 70%);
}

.clientMetrics strong {
  color: #1e293b;
  font-size: 16px;
}

.clientMetrics small {
  color: #7b8a9b;
  font-size: 8px;
}

.clientCard footer {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 10px;
  padding-top: 15px;
  border-top: 1px solid var(--asset-border, #a5f3fc);
}

.clientCard footer > span {
  display: grid;
  gap: 2px;
}

.clientCard footer small {
  color: #8493a3;
  font-size: 8px;
  text-transform: uppercase;
}

.clientCard footer strong {
  color: #334155;
  font-size: 11px;
}

.clientCard footer b {
  color: var(--asset-dark, #0e7490);
  font-size: 11px;
  white-space: nowrap;
}

.clientBreadcrumb {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #8291a0;
  font-size: 12px;
}

.clientBreadcrumb button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--asset-dark, #0e7490);
  font-weight: 800;
}

.clientBreadcrumb strong {
  color: #334155;
}

.alertStrip {
  display: grid;
  grid-template-columns: 46px 1fr auto;
  align-items: center;
  gap: 15px;
  padding: 17px 20px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 14px;
  background: linear-gradient(135deg, var(--asset-soft, #ecfeff), #fff);
  color: #334155;
}

.alertIcon {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 12px;
  background: var(--asset-accent, #0891b2);
  color: #fff;
  font-size: 19px;
}

.alertStrip > div {
  display: grid;
  gap: 4px;
}

.alertStrip strong {
  color: var(--asset-deep, #164e63);
  font-size: 14px;
}

.alertStrip div span {
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.alertStrip > b {
  padding: 8px 11px;
  border-radius: 999px;
  background: #fff;
  color: var(--asset-dark, #0e7490);
  box-shadow: 0 4px 12px rgb(var(--asset-shadow-rgb, 8 145 178) / 10%);
  font-size: 11px;
  white-space: nowrap;
}

.filterToolbar {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(190px, 230px) auto auto;
  align-items: stretch;
  gap: 12px;
  padding: 18px 26px 22px;
  border-bottom: 1px solid var(--asset-border, #a5f3fc);
  background: linear-gradient(135deg, var(--asset-soft, #ecfeff), #fff 82%);
}

.control {
  display: grid;
  min-height: 70px;
  align-content: center;
  gap: 5px;
  padding: 9px 12px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgb(var(--asset-shadow-rgb, 8 145 178) / 7%);
}

.control > span {
  color: var(--asset-deep, #164e63);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.control input,
.control select {
  width: 100%;
  min-height: 34px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #334155;
  font-size: 13px;
}

.selectControl {
  position: relative;
}

.recordCount {
  display: grid;
  min-width: 105px;
  align-content: center;
  justify-items: center;
  gap: 2px;
  padding: 9px 14px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 12px;
  background: var(--asset-accent, #0891b2);
  color: #fff;
}

.recordCount strong {
  font-size: 22px;
  line-height: 1;
}

.recordCount span {
  font-size: 11px;
  font-weight: 800;
}

.clearButton {
  min-height: 70px;
  padding: 12px 18px;
  border: 1px solid var(--asset-accent, #0891b2);
  border-radius: 12px;
  background: #fff;
  color: var(--asset-dark, #0e7490);
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.clearButton:hover:not(:disabled) {
  background: var(--asset-accent, #0891b2);
  color: #fff;
}

.clearButton:disabled {
  border-color: #dbe3ec;
  background: #f8fafc;
  color: #94a3b8;
  opacity: 0.8;
}

.tableWrapper {
  width: 100%;
  overflow-x: auto;
}

.tableWrapper.scrollable {
  max-height: 760px;
  overflow: auto;
}

.tableWrapper table {
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
}

.tableWrapper table.boatTable {
  min-width: 1500px;
}

.tableWrapper th {
  padding: 16px 15px;
  border-bottom: 1px solid var(--asset-border, #a5f3fc);
  background: var(--asset-soft, #ecfeff);
  color: var(--asset-deep, #164e63);
  font-size: 12px;
  font-weight: 800;
  text-align: left;
  white-space: nowrap;
}

.scrollable th {
  position: sticky;
  z-index: 3;
  top: 0;
  box-shadow: 0 1px var(--asset-border, #a5f3fc);
}

.tableWrapper td {
  padding: 17px 15px;
  border-bottom: 1px solid #e2e8f0;
  color: #334155;
  font-size: 13px;
  line-height: 1.5;
  vertical-align: middle;
}

.tableWrapper td > strong,
.tableWrapper td > span:not(.status) {
  display: block;
}

.tableWrapper td > strong {
  color: #1e293b;
  font-size: 14px;
}

.tableWrapper td > span:not(.status) {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}

.tableWrapper tbody tr {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.tableWrapper tbody tr:hover {
  background: var(--asset-soft, #ecfeff);
  box-shadow: inset 5px 0 var(--asset-accent, #0891b2);
}

.serviceDate {
  display: grid !important;
  min-width: 135px;
  gap: 3px;
  margin: 0 !important;
}

.serviceDate strong {
  color: #1e293b;
  font-size: 12px;
  white-space: nowrap;
}

.serviceDate small {
  color: #64748b;
  font-size: 10px;
  white-space: nowrap;
}

.status {
  display: inline-block !important;
  margin: 0 !important;
  padding: 8px 11px;
  border-radius: 999px;
  font-size: 11px !important;
  font-weight: 800;
  white-space: nowrap;
}

.operational {
  background: #dcfce7;
  color: #15803d !important;
}

.dueSoon {
  background: #fef3c7;
  color: #a16207 !important;
}

.underService {
  background: #dbeafe;
  color: #1d4ed8 !important;
}

.expired {
  background: #ffe4e6;
  color: #be123c !important;
}

.actions {
  display: flex !important;
  gap: 7px;
  margin: 0 !important;
  white-space: nowrap;
}

.actions button,
.formActions > button:not(.primary) {
  min-height: 36px;
  padding: 8px 11px;
  border: 1px solid var(--asset-accent, #0891b2);
  border-radius: 9px;
  background: linear-gradient(145deg, #fff, var(--asset-soft, #ecfeff));
  color: var(--asset-dark, #0e7490);
  font-size: 11px;
  font-weight: 800;
  transition: 0.18s;
}

.actions button:hover,
.formActions > button:not(.primary):hover {
  background: var(--asset-accent, #0891b2);
  color: #fff;
}

.deleteButton {
  border-color: #fecdd3 !important;
  color: #be123c !important;
}

.deleteButton:hover {
  border-color: #fb7185 !important;
  background: #fff1f2 !important;
}

.empty {
  display: flex;
  min-height: 240px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 9px;
  padding: 30px;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

.empty strong {
  color: var(--asset-deep, #164e63);
  font-size: 18px;
}

.modalBackdrop {
  position: fixed;
  z-index: 1100;
  inset: 0;
  display: grid;
  overflow-y: auto;
  place-items: center;
  padding: 24px;
  background: rgb(15 23 42 / 64%);
  backdrop-filter: blur(5px);
}

.modal {
  width: min(1080px, 100%);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 70px rgb(15 23 42 / 32%);
}

.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 23px 26px;
  border-bottom: 1px solid var(--asset-border, #a5f3fc);
  background: linear-gradient(135deg, #fff, var(--asset-soft, #ecfeff));
}

.modalHeader > div {
  display: grid;
  gap: 5px;
}

.modalHeader h2 {
  margin: 0;
  color: var(--asset-deep, #164e63);
  font-size: 27px;
}

.modalHeader > button {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  padding: 0;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 11px;
  background: #fff;
  color: var(--asset-dark, #0e7490);
  font-size: 28px;
}

.modal form {
  padding: 26px;
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 19px;
}

.formGrid label {
  display: grid;
  gap: 8px;
}

.formGrid label > span {
  color: #334155;
  font-size: 14px;
  font-weight: 800;
}

.formGrid input,
.formGrid select,
.formGrid textarea {
  width: 100%;
  min-height: 50px;
  padding: 12px 14px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 11px;
  outline: none;
  background: #fff;
  color: #172033;
  font-size: 15px;
}

.formGrid textarea {
  min-height: 130px;
  line-height: 1.55;
  resize: vertical;
}

.formGrid input:focus,
.formGrid select:focus,
.formGrid textarea:focus {
  border-color: var(--asset-accent, #0891b2);
  box-shadow: 0 0 0 4px rgb(var(--asset-shadow-rgb, 8 145 178) / 15%);
}

.formGrid input[readonly],
.formGrid textarea[readonly],
.formGrid select:disabled {
  border-color: #dbe3ec;
  background: #f8fafc;
  color: #475569;
  opacity: 1;
}

.wide {
  grid-column: 1 / -1;
}

.serviceSection {
  display: grid;
  gap: 5px;
  padding: 15px 17px;
  border: 1px solid var(--asset-border, #a5f3fc);
  border-radius: 12px;
  background: linear-gradient(135deg, var(--asset-soft, #ecfeff), #fff);
}

.serviceSection > strong {
  color: var(--asset-deep, #164e63);
  font-size: 18px;
}

.serviceSection > span {
  color: #64748b;
  font-size: 13px;
}

.servicePair {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: minmax(220px, 0.8fr) repeat(2, minmax(0, 1fr));
  align-items: end;
  gap: 16px;
  padding: 17px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.servicePair > strong {
  align-self: center;
  color: var(--asset-deep, #164e63);
  font-size: 14px;
  line-height: 1.4;
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 11px;
  margin-top: 26px;
  padding-top: 21px;
  border-top: 1px solid #e2e8f0;
}

.formActions > button {
  min-height: 50px !important;
  padding-right: 20px !important;
  padding-left: 20px !important;
  font-size: 14px !important;
}

.module button:focus-visible,
.module input:focus-visible,
.module select:focus-visible,
.module textarea:focus-visible {
  outline: 3px solid rgb(var(--asset-shadow-rgb, 8 145 178) / 28%);
  outline-offset: 2px;
}

@media (max-width: 1250px) {
  .clientGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filterToolbar {
    grid-template-columns: minmax(280px, 1fr) minmax(190px, 230px);
  }
}

@media (max-width: 900px) {
  .statistics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .banner {
    align-items: stretch;
    flex-direction: column;
  }

  .bannerActions {
    justify-content: flex-start;
  }

  .alertStrip {
    grid-template-columns: 44px 1fr;
  }

  .alertStrip > b {
    grid-column: 2;
    width: max-content;
  }
}

@media (max-width: 680px) {
  .module {
    gap: 20px;
    padding-top: 18px;
  }

  .banner {
    padding: 25px 21px;
  }

  .bannerActions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .primary,
  .secondary {
    width: 100%;
  }

  .statistics,
  .clientGrid,
  .filterToolbar,
  .formGrid {
    grid-template-columns: 1fr;
  }

  .clientGrid {
    padding: 18px;
  }

  .clientCard {
    min-height: 300px;
  }

  .sectionHeader,
  .registerHeader {
    align-items: flex-start;
    flex-direction: column;
    padding: 21px;
  }

  .recordCount,
  .clearButton {
    width: 100%;
  }

  .alertStrip {
    grid-template-columns: 1fr;
  }

  .alertStrip > b {
    grid-column: auto;
  }

  .modalBackdrop {
    padding: 12px;
  }

  .modal {
    max-height: calc(100vh - 24px);
  }

  .modalHeader,
  .modal form {
    padding: 21px;
  }

  .wide {
    grid-column: auto;
  }

  .servicePair {
    grid-column: auto;
    grid-template-columns: 1fr;
  }

  .formActions {
    flex-direction: column-reverse;
  }

  .formActions button {
    width: 100%;
  }
}
